import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export function SunsetBanner() {
  const { t } = useTranslation('landing')

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-bg-surface/95 backdrop-blur-md border-b border-brand-accent/30">
      <div className="container flex items-center justify-center gap-2 py-2">
        <p className="font-body-ja text-sm text-white/80">
          {t('sunset.bannerText')}
        </p>
        <Link
          to="/sunset"
          className="font-body-en text-sm text-brand-accent hover:text-brand-accent/80 transition-colors whitespace-nowrap"
        >
          {t('sunset.bannerLink')} →
        </Link>
      </div>
    </div>
  )
}
